const swea = require('swea');
const DepthProfileInteraction = swea.editor.interactions.DepthProfileInteraction;
const InstructionServiceActions = swea.react.actions.InstructionServiceActions;
const ViewerManager = swea.editor.ViewerManager;
const InteractionManager = swea.editor.InteractionManager;


class CustomDepthProfileInteraction extends DepthProfileInteraction {
  /**
   * The constructor.
   * @param { object } options An option object, see {@link DepthProfileInteraction} for more info.
   */
  constructor(options) {
    super(options);
    this._disabledInteractionClasses = [];
  }
  
  /**
   * Initializes the interaction.
   * @param element the element that the interaction listens to.
   * @param viewerId the viewer id of the viewer the interaction operates in.
   */
  initialize(element, viewerId){
    super.initialize(element, viewerId);

    // When user closes the tool
    this.addTrigger(new swea.editor.interactions.EventHandler(
      [swea.editor.interactions.eventCodes.ESC],
      this,
      () => {
        this.terminate();
      }
    ));
  }

  /**
   * When the interaction is initialized open the correct context menu.
   * @param element { DOMElement } The element that the interaction works on
   * @param viewerId { number } The ID of the viewer.
   * @override
   */
  whenInitialized(element, viewerId){
    super.whenInitialized(element, viewerId);

    InstructionServiceActions.showInstruction('instructions.depth_line');
    ViewerManager.instance().getViewerById(viewerId).setCursor('crosshair');
    this._disabledInteractionClasses = InteractionManager.instance().disableContinuousInteractions();
  }
  
  /**
   * Called before measurement.
   * @private
   * @override
   */  
  _beforeMeasure() {
    this.getViewer().setCursor('wait');
    this.getSceneViewer().redraw();
  }
  
  whenTerminated(element, viewerId){
    super.whenTerminated(element, viewerId);
    ViewerManager.instance().getViewerById(viewerId).setCursor('default');
    InteractionManager.instance().enableContinuousInteractions(this._disabledInteractionClasses);
    InstructionServiceActions.hideInstruction();
  }
}
export default CustomDepthProfileInteraction;
